import React, { useState } from 'react';
import { Box, Grid, Typography, Button, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, TextField, MenuItem, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';

// Dados simulados para controle de estoque
const simulatedStock = [
  { id: 1, product: 'Fertilizante A', quantity: 100, price: 50, supplier: 'Fornecedor 1' },
  { id: 2, product: 'Herbicida B', quantity: 200, price: 30, supplier: 'Fornecedor 2' },
  { id: 3, product: 'Semente de Soja', quantity: 10, price: 25, supplier: 'Fornecedor 3' },
];

const StockControl = () => {
  const [stock, setStock] = useState(simulatedStock);
  const [showModal, setShowModal] = useState(false);
  const [formData, setFormData] = useState({
    product: '',
    quantity: '',
    price: '',
    supplier: '',
  });

  const handleAddItem = () => {
    setShowModal(true);
  };

  const handleEditItem = (item) => {
    setFormData(item);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setFormData({
      product: '',
      quantity: '',
      price: '',
      supplier: '',
    });
  };

  const handleSubmit = () => {
    if (formData.id) {
      // Editando item existente
      setStock(stock.map(item => item.id === formData.id ? formData : item));
    } else {
      // Adicionando novo item
      const newItem = { ...formData, id: stock.length + 1 };
      setStock([...stock, newItem]);
    }
    handleCloseModal();
  };

  const getStockColor = (quantity) => {
    if (quantity > 50) return 'green';
    if (quantity > 20) return 'yellow';
    return 'red';
  };

  return (
    <Box sx={{ padding: 4 }}>
      <Typography variant="h5" sx={{ fontWeight: 'bold', marginBottom: '20px' }}>Controle de Estoque</Typography>

      {/* Tabela de Itens no Estoque */}
      <TableContainer component={Paper} sx={{ marginBottom: '30px' }}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Produto</TableCell>
              <TableCell>Quantidade</TableCell>
              <TableCell>Preço</TableCell>
              <TableCell>Fornecedor</TableCell>
              <TableCell>Disponibilidade</TableCell>
              <TableCell>Ações</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {stock.map((item) => (
              <TableRow key={item.id}>
                <TableCell>{item.product}</TableCell>
                <TableCell>{item.quantity}</TableCell>
                <TableCell>{item.price}</TableCell>
                <TableCell>{item.supplier}</TableCell>
                <TableCell>
                  <Typography 
                    sx={{ 
                      color: getStockColor(item.quantity), 
                      fontWeight: 'bold'
                    }}
                  >
                    {item.quantity > 50 ? 'Suficiente' : item.quantity > 20 ? 'Baixo' : 'Crítico'}
                  </Typography>
                </TableCell>
                <TableCell>
                  <Button variant="outlined" color="primary" size="small" onClick={() => handleEditItem(item)}>Editar</Button>
                  <Button variant="outlined" color="error" size="small" sx={{ marginLeft: '10px' }}>Excluir</Button>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      {/* Botão de Adicionar Novo Item */}
      <Button variant="contained" color="primary" onClick={handleAddItem}>Adicionar Item</Button>

      {/* Modal para Adicionar/Editar Item */}
      <Dialog open={showModal} onClose={handleCloseModal}>
        <DialogTitle>{formData.id ? 'Editar Item' : 'Adicionar Item'}</DialogTitle>
        <DialogContent>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <TextField
                label="Produto"
                fullWidth
                value={formData.product}
                onChange={(e) => setFormData({ ...formData, product: e.target.value })}
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <TextField
                label="Quantidade"
                type="number"
                fullWidth
                value={formData.quantity}
                onChange={(e) => setFormData({ ...formData, quantity: e.target.value })}
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <TextField
                label="Preço"
                type="number"
                fullWidth
                value={formData.price}
                onChange={(e) => setFormData({ ...formData, price: e.target.value })}
              />
            </Grid>

            <Grid item xs={12}>
              <TextField
                label="Fornecedor"
                fullWidth
                value={formData.supplier}
                onChange={(e) => setFormData({ ...formData, supplier: e.target.value })}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseModal} color="secondary">Cancelar</Button>
          <Button onClick={handleSubmit} variant="contained" color="primary">{formData.id ? 'Salvar Alterações' : 'Adicionar Item'}</Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default StockControl;
